import getApi from '../../api/apisauceConfig'
import { Contact } from '../../model/Contact'
import { serializeContact } from './mapper/contact.mapper'

export const updateContact = (id: string, contactPayload: Partial<Contact>) =>
  getApi().put<Contact>(`/contacts/${id}`, serializeContact(contactPayload))
